import PropTypes from 'prop-types';
import React from 'react';
import { Sticky } from 'react-sticky';
import Media from 'react-media';
import MenuButton from 'react-aria-menubutton';
import BetaBadge from '../../BetaBadge';
import styles from './styles.module.styl';
import canUseDOM from '../../../util/canUseDOM';

const Empty = (props) => props.children({ ...props, style: {}, isSticky: false });

const TocBar = ({ title, titles, showBetaBadge }) => {
  // Prevent rendering Sticky component in server-side since it won't find the StickyContainer
  // https://github.com/MichalZalecki/react-portal-universal/blob/09841c7db4f61d24f7d61a6cf0b1d4502bdc8d8b/src/server.ts#L12
  const ClientSideSticky = canUseDOM() ? Sticky : Empty;

  return (
    <Media query="(max-width: 992px)">
      {isMobile => (
        <ClientSideSticky
          disableCompensation={isMobile}
          topOffset={100}
        >
          {({ style, isSticky }) => (
            <div
              className={`
                ${styles.tocBar}
                ${(isSticky && !isMobile) ? styles.sticky : ''}
              `}
              style={(isSticky && !isMobile) ? style : {}}
            >
              <h1 className={styles.title}>
                {title}
                {(showBetaBadge && !isSticky) && <BetaBadge />}
              </h1>
              <MenuButton.Wrapper>
                <MenuButton.Button className={styles.dropdownButton}>
                  <span className={styles.dropdownButtonText}>In this article</span>
                  <i className={`${styles.dropdownButtonIcon} icon icon-budicon-460`} />
                </MenuButton.Button>
                <MenuButton.Menu className={styles.dropdownMenu}>
                  <ul className={styles.dropdownMenuContent}>
                    {titles.map(item => (
                      <li
                        key={item.content}
                        className={[
                          styles.dropdownItem,
                          item.level === 2 ? styles.mainItem : styles.subItem
                        ].join(' ')}
                      >
                        <MenuButton.MenuItem>
                          <a href={`#${item.anchor}`} className={styles.dropdownItemLink}>
                            {item.content}
                          </a>
                        </MenuButton.MenuItem>
                      </li>
                    ))}
                  </ul>
                </MenuButton.Menu>
              </MenuButton.Wrapper>
            </div>
          )}
        </ClientSideSticky>
      )}
    </Media>
  );
};

TocBar.propTypes = {
  title: PropTypes.string.isRequired,
  titles: PropTypes.arrayOf(
    PropTypes.shape({
      content: PropTypes.string.isRequired,
      anchor: PropTypes.string.isRequired,
      level: PropTypes.number.isRequired
    })
  ).isRequired,
  showBetaBadge: PropTypes.bool.isRequired
};

export default TocBar;
